import React from 'react'
import { Skeleton } from 'antd'
import styles from './index.module.scss'
interface IProductListSkeletonProps {
  column?: number | 'auto',
  lens?: number
}

const ProductListSkeleton: React.FC<IProductListSkeletonProps> = ({column = 3, lens = 16}) => {
  return (
    <div className={styles['skeleton-list']}>
      {[...Array(lens)].map((_, index) => (
        <div className={`${styles['skeleton-item']} ${
          column ? styles[`column-${column}`] : styles[`column-4`]
        }`}  key={index}>
          <Skeleton
            active
            paragraph={{ rows: 1 }}
            title={{ width: '50%' }}
            avatar={{ shape: 'square', size: 'large' }}
          />
        </div> 
      ))}
    </div>
  )
}

export default ProductListSkeleton
